import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { redirects } from '@lib/redirects';
import { Route } from '@packages/router/lib/route';
import React from 'react';
import { TABS as EditFormTabs } from './Edit/components/EditStepper/Tabs';

export const routes$ = {
    Index: AsyncPageRender(() => pageModule(import('./Index'))),
    Edit: AsyncPageRender(() => pageModule(import('./Edit'))),
    List: AsyncPageRender(() => pageModule(import('./List'))),
    Create: AsyncPageRender(() => pageModule(import('./CreateOrder'))),
    Search: AsyncPageRender(() => pageModule(import('./Search'))),

    // TODO: implement role view
    OrderForm: AsyncPageRender(() => pageModule(import('./OrderForm'))),

    OrderPlacement: AsyncPageRender(() => pageModule(import('./Placement'))),
};

function Router() {
    return (
        <>
            {redirects({
                '/orders/:order/edit': ({ order }) => `/orders/${order}/edit/${EditFormTabs[0].name}`,
                '/orders/:order/order-form': ({ order }) => `/orders/${order}/order-form/general`,
            })}

            <Route
                name={'Order.Edit'}
                exact
                path={'/orders/:order/edit/:tab'}
                component={ProtectedRoute(routes$.Edit)}
            />
            <Route
                name={'Order.orderForm'}
                exact
                path={'/orders/:order/order-form/:tab'}
                component={ProtectedRoute(routes$.OrderForm)}
            />
            <Route
                name={'Order.placeOrder'}
                exact
                path={'/orders/:order/placement/:tab'}
                component={ProtectedRoute(routes$.OrderPlacement)}
            />
            <Route
                name={'Order.Create'}
                exact
                path={'/orders/create/:order/:tab'}
                component={ProtectedRoute(routes$.Create)}
            />

            <Route
                name={'Order.Operations.Search'}
                path={'/operations/search-order'}
                component={ProtectedRoute(routes$.Search)}
            />
            <Route
                name={'Order.Operations'}
                path={'/operations/orders/:type/:tab?'}
                component={ProtectedRoute(routes$.Index)}
            />
            <Route
                name={'Order.OperationsEdit'}
                path={'/operations/orders/:tab/:order/edit'}
                component={ProtectedRoute(routes$.Edit)}
            />
        </>
    );
}

export default Router;
